import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionFunnelWidget = ({ stages = [] }) => {
  const maxValue = Math.max(...stages?.map(s => s?.value));

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Conversion Funnel</h3>
        <button className="flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors">
          <Icon name="Settings" size={16} />
          <span className="hidden sm:inline">Configure</span>
        </button>
      </div>
      <div className="space-y-4">
        {stages?.map((stage, index) => {
          const widthPercentage = (stage?.value / maxValue) * 100;
          const dropoffRate = index > 0 ? 
            ((stages?.[index - 1]?.value - stage?.value) / stages?.[index - 1]?.value * 100)?.toFixed(1) : 
            null;

          return (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${stage?.iconBg}`}>
                    <Icon name={stage?.icon} size={16} className={stage?.iconColor} />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">{stage?.name}</p>
                    <p className="text-xs text-muted-foreground">{stage?.description}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-foreground whitespace-nowrap">{stage?.value?.toLocaleString()}</p>
                  <p className="text-xs text-muted-foreground">{stage?.percentage}%</p>
                </div>
              </div>
              <div className="relative h-12 bg-muted rounded-lg overflow-hidden">
                <div 
                  className={`absolute inset-y-0 left-0 ${stage?.barColor} flex items-center justify-between px-4 transition-all duration-500`}
                  style={{ width: `${widthPercentage}%` }}
                >
                  <span className="text-sm font-medium text-white">{stage?.value?.toLocaleString()} users</span>
                  {dropoffRate && (
                    <span className="text-xs text-white/80">-{dropoffRate}% drop-off</span>
                  )}
                </div>
              </div>
              {index < stages?.length - 1 && (
                <div className="flex items-center justify-center py-2">
                  <Icon name="ChevronDown" size={20} className="text-muted-foreground" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Overall Conversion Rate</p>
            <p className="text-2xl font-bold text-foreground">
              {((stages?.[stages?.length - 1]?.value / stages?.[0]?.value) * 100)?.toFixed(2)}%
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-muted-foreground mb-1">Total Conversions</p>
            <p className="text-2xl font-bold text-success">{stages?.[stages?.length - 1]?.value?.toLocaleString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionFunnelWidget;